// components
import Picture from '../../../picture';

// images
import EtmWebp from '../images/shops/etm.webp';
import EtmPng from '../images/shops/etm.png';
import VseInstrumentyWebp from '../images/shops/vse-instrumenty.webp';
import VseInstrumentyPng from '../images/shops/vse-instrumenty.png';
import ChipDipWebp from '../images/shops/chip-dip.webp';
import ChipDipPng from '../images/shops/chip-dip.png';
import OnlineTradeWebp from '../images/shops/online-trade.webp';
import OnlineTradePng from '../images/shops/online-trade.png';
import KomusWebp from '../images/shops/komus.webp';
import KomusPng from '../images/shops/komus.png';
import KuvaldaWebp from '../images/shops/kuvalda.webp';
import KuvaldaPng from '../images/shops/kuvalda.png';
import XcomWebp from '../images/shops/xcom.webp';
import XcomPng from '../images/shops/xcom.png';
import Rs24Webp from '../images/partners/rus-svet-logo.webp';
import Rs24Png from '../images/partners/rus-svet-logo.png';

const ONLINE_STORES: { name: string; url: string; logoWebp: string; logoFallback: string }[] = [
    { name: 'ЭТМ', url: 'https://www.etm.ru/brand/432_iek', logoWebp: EtmWebp, logoFallback: EtmPng },
    { name: 'RS24', url: 'https://rs24.ru/landing/IEK1', logoWebp: Rs24Webp, logoFallback: Rs24Png },
    { name: 'ВсеИнструменты.ру', url: 'https://www.vseinstrumenti.ru/brand/iek-1219/', logoWebp: VseInstrumentyWebp, logoFallback: VseInstrumentyPng },
    { name: 'Чип и Дип', url: 'https://www.chipdip.ru/distributor/iek', logoWebp: ChipDipWebp, logoFallback: ChipDipPng },
    { name: 'Онлайн трейд', url: 'https://www.onlinetrade.ru/brands/iek/', logoWebp: OnlineTradeWebp, logoFallback: OnlineTradePng },
    { name: 'Комус', url: 'https://www.komus.ru/trademarks/IEK/t/5088/?listingMode=PLAIN', logoWebp: KomusWebp, logoFallback: KomusPng },
    { name: 'Кувалда.ру', url: 'https://www.kuvalda.ru/catalog/brands/iek/', logoWebp: KuvaldaWebp, logoFallback: KuvaldaPng },
    { name: 'xcom-shop.ru', url: 'https://www.xcom-shop.ru/brands/iek/', logoWebp: XcomWebp, logoFallback: XcomPng },
];

export default function OfficialOnlineStores() {
    return (
        <div className="official-online-stores-block">
            <h2 className="official-online-stores-block__title">Официальные интернет-магазины</h2>
            <div className="official-online-stores-block__grid">
                {ONLINE_STORES.map(({ name, url, logoWebp, logoFallback }) => (
                    <a
                        key={name}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="official-online-stores-block__card"
                    >
                        <Picture
                            webp={logoWebp}
                            fallback={logoFallback}
                            alt={name}
                            className="official-online-stores-block__card-logo"
                        />
                    </a>
                ))}
            </div>
        </div>
    );
}
